module.exports = __webpack_public_path__ + "img/fail.fe5d0cf3.png";